/* global Audio Date */
import React from 'react'

class PlayerAudioShell extends React.Component {
  state = {
    isPlaying: false,
    songStartedAt: null,
  }

  componentDidMount() {
    this.audio = new Audio()
    this.audio.onended = () => this.setState({ isPlaying: false })
    if (this.props.songStatus) this.setState({ songStartedAt: Date.now() })
  }

  UNSAFE_componentWillReceiveProps(np) {
    if (!this.props.songStatus && np.songStatus) {
      if (this.audio) {
        this.audio.pause()
        this.audio.src = ''
      }
      this.setState({ songStartedAt: Date.now(), isPlaying: false }, () => {
        if (np.autoPlay && np.song) {
          setTimeout(() => this._playPause(), 300)
        }
      })
      return
    }

    if (this.props.songStatus && np.songStatus && this.props.autoPlay !== np.autoPlay) {
      if (np.autoPlay && !this.state.isPlaying) {
        this._playPause()
      } else if (!np.autoPlay && this.state.isPlaying) {
        this.audio.pause()
        this.setState({ isPlaying: false })
      }
    }
  }

  componentWillUnmount() {
    if (this.audio) {
      this.audio.pause()
      this.audio.src = ''
      this.audio = null
    }
  }

  _playPause = () => {
    const { song } = this.props
    const { isPlaying, songStartedAt } = this.state
    if (!song) return
    const audioUrl = song.public_url || song.direct_url
    if (!audioUrl) return

    if (isPlaying) {
      this.audio.pause()
      this.setState({ isPlaying: false })
    } else {
      if (this.audio.src !== audioUrl) this.audio.src = audioUrl
      if (songStartedAt) {
        const elapsed = (Date.now() - songStartedAt) / 1000
        const maxTime = parseFloat(song.length_in_seconds) || Infinity
        if (elapsed < maxTime) this.audio.currentTime = Math.max(0, elapsed)
      }
      this.audio
        .play()
        .then(() => this.setState({ isPlaying: true }))
        .catch(() => {})
    }
  }

  render() {
    const { song, children } = this.props
    const { isPlaying } = this.state
    const hasAudio = !!(song && (song.public_url || song.direct_url))
    return (
      <React.Fragment>
        {typeof children === 'function'
          ? children({ isPlaying, hasAudio, onPlayPause: this._playPause })
          : children}
      </React.Fragment>
    )
  }
}

export default PlayerAudioShell
